// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__i9MNa","LinkWrapper":"Header_LinkWrapper__JzzQb","Link":"Header_Link__UR7t6","isActive":"Header_isActive__Xa6vZ"};